/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DateSignedTab
 */
export interface DateSignedTab {
    /**
     * The X-coordinate of the signer’s signing date on the page, in pixels
     * @type {number}
     * @memberof DateSignedTab
     */
    xPosition: number;
    /**
     * The Y-coordinate of the signer’s signing date on the page, in pixels
     * @type {number}
     * @memberof DateSignedTab
     */
    yPosition: number;
    /**
     * The width of the signer’s signing date on the page, in pixels
     * @type {number}
     * @memberof DateSignedTab
     */
    width: number;
    /**
     * The height of the signer’s signing date on the page, in pixels
     * @type {number}
     * @memberof DateSignedTab
     */
    height: number;
    /**
     * The signer’s signing date font family
     * @type {string}
     * @memberof DateSignedTab
     */
    font: DateSignedTabFontEnum;
    /**
     * The signer’s signing date font color
     * @type {string}
     * @memberof DateSignedTab
     */
    fontColor: DateSignedTabFontColorEnum;
    /**
     * The signer’s signing date font size
     * @type {string}
     * @memberof DateSignedTab
     */
    fontSize: DateSignedTabFontSizeEnum;
    /**
     * Indicates whether the signer’s signing date is bold
     * @type {boolean}
     * @memberof DateSignedTab
     */
    bold: boolean;
    /**
     * Indicates whether the signer’s signing date is italic
     * @type {boolean}
     * @memberof DateSignedTab
     */
    italic: boolean;
    /**
     * Indicates whether the signer’s signing date is underlined
     * @type {boolean}
     * @memberof DateSignedTab
     */
    underline: boolean;
    /**
     * The ID of the document where the signer’s signing date field is placed
     * @type {string}
     * @memberof DateSignedTab
     */
    documentId: string;
    /**
     * The page number of the document where the signer’s signing date field is placed
     * @type {number}
     * @memberof DateSignedTab
     */
    pageNumber: number;
    /**
     * The signer’s signing date value
     * @type {string}
     * @memberof DateSignedTab
     */
    value: string;
    /**
     * Indicates whether the signer is required to fill out this field
     * @type {boolean}
     * @memberof DateSignedTab
     */
    required: boolean;
    /**
     * Indicates whether the field is locked and cannot be edited by the signer
     * @type {boolean}
     * @memberof DateSignedTab
     */
    locked: boolean;
}


/**
 * @export
 */
export const DateSignedTabFontEnum = {
    arial: 'arial',
    arialnarrow: 'arialnarrow',
    calibri: 'calibri',
    couriernew: 'couriernew',
    garamond: 'garamond',
    georgia: 'georgia',
    helvetica: 'helvetica',
    lucidaconsole: 'lucidaconsole',
    msgothic: 'msgothic',
    msmincho: 'msmincho',
    tahoma: 'tahoma',
    timesnewroman: 'timesnewroman',
    trebuchet: 'trebuchet',
    verdana: 'verdana',
    unknown_default_open_api: '11184809'
} as const;
export type DateSignedTabFontEnum = typeof DateSignedTabFontEnum[keyof typeof DateSignedTabFontEnum];

/**
 * @export
 */
export const DateSignedTabFontColorEnum = {
    black: 'black',
    brightblue: 'brightblue',
    brightred: 'brightred',
    darkgreen: 'darkgreen',
    darkred: 'darkred',
    gold: 'gold',
    green: 'green',
    navyblue: 'navyblue',
    purple: 'purple',
    white: 'white',
    unknown_default_open_api: '11184809'
} as const;
export type DateSignedTabFontColorEnum = typeof DateSignedTabFontColorEnum[keyof typeof DateSignedTabFontColorEnum];

/**
 * @export
 */
export const DateSignedTabFontSizeEnum = {
    size7: 'size7',
    size8: 'size8',
    size9: 'size9',
    size10: 'size10',
    size11: 'size11',
    size12: 'size12',
    size14: 'size14',
    size16: 'size16',
    size18: 'size18',
    size20: 'size20',
    size22: 'size22',
    size24: 'size24',
    size26: 'size26',
    size28: 'size28',
    size36: 'size36',
    size48: 'size48',
    size72: 'size72',
    unknown_default_open_api: '11184809'
} as const;
export type DateSignedTabFontSizeEnum = typeof DateSignedTabFontSizeEnum[keyof typeof DateSignedTabFontSizeEnum];


/**
 * Check if a given object implements the DateSignedTab interface.
 */
export function instanceOfDateSignedTab(value: object): boolean {
    if (!('xPosition' in value)) return false;
    if (!('yPosition' in value)) return false;
    if (!('width' in value)) return false;
    if (!('height' in value)) return false;
    if (!('font' in value)) return false;
    if (!('fontColor' in value)) return false;
    if (!('fontSize' in value)) return false;
    if (!('bold' in value)) return false;
    if (!('italic' in value)) return false;
    if (!('underline' in value)) return false;
    if (!('documentId' in value)) return false;
    if (!('pageNumber' in value)) return false;
    if (!('value' in value)) return false;
    if (!('required' in value)) return false;
    if (!('locked' in value)) return false;
    return true;
}

export function DateSignedTabFromJSON(json: any): DateSignedTab {
    return DateSignedTabFromJSONTyped(json, false);
}

export function DateSignedTabFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateSignedTab {
    if (json == null) {
        return json;
    }
    return {
        
        'xPosition': json['xPosition'],
        'yPosition': json['yPosition'],
        'width': json['width'],
        'height': json['height'],
        'font': json['font'],
        'fontColor': json['fontColor'],
        'fontSize': json['fontSize'],
        'bold': json['bold'],
        'italic': json['italic'],
        'underline': json['underline'],
        'documentId': json['documentId'],
        'pageNumber': json['pageNumber'],
        'value': json['value'],
        'required': json['required'],
        'locked': json['locked'],
    };
}

export function DateSignedTabToJSON(value?: DateSignedTab | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'xPosition': value['xPosition'],
        'yPosition': value['yPosition'],
        'width': value['width'],
        'height': value['height'],
        'font': value['font'],
        'fontColor': value['fontColor'],
        'fontSize': value['fontSize'],
        'bold': value['bold'],
        'italic': value['italic'],
        'underline': value['underline'],
        'documentId': value['documentId'],
        'pageNumber': value['pageNumber'],
        'value': value['value'],
        'required': value['required'],
        'locked': value['locked'],
    };
}

